import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          This app is no longer available.
          <br/>
          It may be revived soon.
        </p>        
        <p>Stay Tuned!!!</p>
      </header>
    </div>
  );
}

export default App;
